import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';
import MoveIcon from '@common/images/move_icon.svg';
import './style.scss';

const ENTER_KEY = 13;
/**
 * SlideOneOption: Option component associated with DesignSection
 * first slide [verify-snp-sequence]
 */

export function SlideOneOption(props) {
  const onKeyDown = (event) =>
    event.keyCode === ENTER_KEY && props.addCard(event);

  return (
    <div className='slideOneOption' tabIndex='0' onKeyDown={onKeyDown}>
      <Image src={MoveIcon} alt='movecardIcon' onClick={props.addCard} />
      <p>{props.text}</p>
    </div>
  );
}

SlideOneOption.propTypes = {
  /**
   * Function to invoke when SetAsNext Button is clicked
   */
  addCard: PropTypes.func,
  /**
   * Text to be displayed in Card.
   */
  text: PropTypes.string,
};

SlideOneOption.defaultProps = {
  text: '',
};
